export function cycleColumnSort(columnKey, current) {
  if (current.key !== columnKey) return { key: columnKey, dir: "asc" };
  return { key: columnKey, dir: current.dir === "asc" ? "desc" : "asc" };
}

/** @param {unknown} v */
export function numOrZero(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function compareLabelInsensitive(a, b) {
  return String(a ?? "").localeCompare(String(b ?? ""), undefined, { sensitivity: "base" });
}

/**
 * Shared sort for funds / SMAs tables (name, AUM, week–year, 365d columns).
 * @param {{
 *   entries: { key: string; id: unknown; data: unknown }[];
 *   metricsMap: Map<string, { aum?: unknown; week?: unknown; month?: unknown; quarter?: unknown; year?: unknown; days365?: unknown }>;
 *   sort: { key: string; dir: string };
 *   defaultMetrics: { aum: number; week: number; month: number; quarter: number; year: number; days365: number };
 *   nameCmp: (a: { key: string; id: unknown; data: unknown }, b: typeof a) => number;
 * }} p
 */
export function sortFundSmaTableEntries({ entries, metricsMap, sort, defaultMetrics, nameCmp }) {
  const mul = sort.dir === "asc" ? 1 : -1;
  return [...entries].sort((ea, eb) => {
    const ma = metricsMap.get(ea.key) ?? defaultMetrics;
    const mb = metricsMap.get(eb.key) ?? defaultMetrics;
    let c = 0;
    switch (sort.key) {
      case "name":
        c = nameCmp(ea, eb);
        break;
      case "aum":
        c = numOrZero(ma.aum) - numOrZero(mb.aum);
        break;
      case "week":
        c = numOrZero(ma.week) - numOrZero(mb.week);
        break;
      case "month":
        c = numOrZero(ma.month) - numOrZero(mb.month);
        break;
      case "quarter":
        c = numOrZero(ma.quarter) - numOrZero(mb.quarter);
        break;
      case "year":
        c = numOrZero(ma.year) - numOrZero(mb.year);
        break;
      case "days365":
        c = numOrZero(ma.days365) - numOrZero(mb.days365);
        break;
      default:
        c = nameCmp(ea, eb);
    }
    if (c !== 0) return c * mul;
    return nameCmp(ea, eb) * mul;
  });
}
